module.exports = __webpack_public_path__ + "img/box7.bcce59c7.png";